// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1T14En3O3CJsaBEagzxjrx {\n  padding: 7px 13px;\n}\n", ""]);
// Exports
exports.locals = {
	"value": "_1T14En3O3CJsaBEagzxjrx"
};
module.exports = exports;
